import { render, staticRenderFns } from "./FIFClientContact.vue?vue&type=template&id=24b43048&"
import script from "./FIFClientContact.vue?vue&type=script&lang=js&"
export * from "./FIFClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports